import React from "react";
import PropTypes from "prop-types";
import formField from "../formField";

export const rounder = (value, roundDigits = "2") =>
  value && value.toString() ? Number(value).toFixed(roundDigits) : null;

export class NumberInput extends React.Component {
  componentDidMount() {
    const value = this.props.input.value;
    this.roundValue(value, false);
  }

  roundValue = (value, change = true) => {
    const roundedVal = rounder(value, this.props.roundDigits);
    this.props.input.onChange(roundedVal);

    if (change) {
      this.props.input.onBlur(roundedVal);
    }
  };

  handleBlur = e => {
    const value = e.target.value;
    this.roundValue(value);
  };

  numberInputOnWheelPreventChange = e => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target && e.target.focus();
    }, 0);
  };

  render() {
    const {
      type,
      className,
      input,
      autoComplete,
      readOnly,
      disabled,
      inputProps
    } = this.props;

    return (
      <input
        type={type}
        autoComplete={autoComplete}
        id={input.name}
        className={`form-control ${className}`}
        readOnly={readOnly}
        disabled={disabled}
        {...input}
        {...inputProps}
        onBlur={this.handleBlur}
        onWheel={this.numberInputOnWheelPreventChange}
      />
    );
  }
}

export default formField(NumberInput);

NumberInput.defaultProps = {
  type: "number",
  className: "",
  autoComplete: "off",
  readOnly: false,
  disabled: false,
  roundDigits: 2,
  inputProps: {}
};

NumberInput.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  roundDigits: PropTypes.number,
  inputProps: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/NumberInput/NumberInput.jsx